export default "__VITE_PUBLIC_ASSET__c078c072__"